import { useState } from 'react';
import { Icon } from '@iconify/react';
import roundFilterList from '@iconify/icons-ic/round-filter-list';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import { FaFileInvoice } from 'react-icons/fa';
import { HiStatusOnline, HiOutlineStatusOffline } from 'react-icons/hi';
import { RiListSettingsLine } from 'react-icons/ri';
import searchFill from '@iconify/icons-eva/search-fill';
import { BiCloudUpload, BiCloudDownload } from 'react-icons/bi';
import CloseIcon from '@mui/icons-material/Close';
// material
import { styled } from '@mui/material/styles';
import {
  Box,
  Tooltip,
  IconButton,
  Typography,
  Grid,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Autocomplete,
  InputAdornment
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RootStyle, SearchStyle } from '../Global/Styling';
import Loader from '../Global/Loader';
import RecievableService from '../services/RecievableService';
// ---------------------------------------------------------
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import useGlobalSelector from '../../store/Slice/Global/GlobalSelector';
import { getBankBranchData, setBranchDetails } from '../../store/Slice/Global/GlobalSlice';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { DownloadReceivableRecords } from '../../store/Slice/Receive/ReceiveSlice';
// ----------------------------------------------------------------------
const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  margin: '0 3px',
  [`&:hover`]: {
    color: theme.palette.primary.main
  }
}));

const { DownloadReceivableReports } = RecievableService;

export default function ReceivableFileToolbar({
  selected,
  setFilterParameter,
  filterParameter,
  filterName,
  onFilterName
}) {
  const [isOpenFilter, openFilter] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openAssign, setOpenAssign] = useState(false);
  const [assignValue, setAssignValue] = useState(' ');
  const [openLoader, setOpenLoader] = useState(false);
  const [downloadPopup, setDownloadPopup] = useState(false);
  const [sameBankPopUp, setSameBankPopUp] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { LoginData } = useLoginSelector();
  const { LoanTypeDrop, BankBranchDrop, BankDrop } = useGlobalSelector();

  const handleRemoveFilter = (e) => {
    setFilterParameter({
      loanTypeId: null,
      bankId: null,
      branchId: null
    });
  };

  const handleDownloadReceivableReports = async () => {
    try {
      setDownloadPopup(false);
      setOpenLoader(true);
      const credentials = {
        companyId: LoginData?.companyId,
        userId: LoginData?.userId,
        accessLevelId: LoginData?.accessLevelId,
        entityListRequestModel: {
          searchLiteral: null,
          pageSize: 1000,
          sortOrder: 'asc',
          pageNumber: 1
        },
        filterModel: {
          bankId: filterParameter?.bankId || null,
          branchId: filterParameter?.branchId || null,
          loanTypeId: filterParameter?.loanTypeId || null
        },
        revenueFileStatusId: 128
      };

      const DownloadReceivableReportsResponse = await dispatch(
        DownloadReceivableRecords(credentials)
      );

      // console.log('sss DownloadReceivableReportsResponse', DownloadReceivableReportsResponse);

      let blob;
      // Case A: fetch Response object -> call .blob()
      if (
        DownloadReceivableReportsResponse &&
        typeof DownloadReceivableReportsResponse.blob === 'function'
      ) {
        blob = await DownloadReceivableReportsResponse.blob();
      } else if (
        DownloadReceivableReportsResponse &&
        typeof DownloadReceivableReportsResponse === 'object' &&
        DownloadReceivableReportsResponse.data
      ) {
        // Case B: wrapper object with `data` field (string CSV)
        const csv = DownloadReceivableReportsResponse.data;
        blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      } else if (typeof DownloadReceivableReportsResponse === 'string') {
        // Case C: function returned raw CSV string
        blob = new Blob([DownloadReceivableReportsResponse], { type: 'text/csv;charset=utf-8;' });
      } else {
        throw new Error('Unexpected download response format');
      }

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'recievable-mis-report.csv');
      document.body.appendChild(link);
      link.click();
      // cleanup URL object
      window.URL.revokeObjectURL(url);
      link.remove();
    } catch (error) {
      console.error('error', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const handleButtonClick = (e) => {
    if (selected && selected.length > 0) {
      const bankIds = selected.map((item) => item.bankId);
      const branchNames = selected.map((item) => item.branchName);
      const allSameBankName = bankIds.every((bankId) => bankId === bankIds[0]);
      const allSameBranchName = branchNames.every((branchName) => branchName === branchNames[0]);

      if (allSameBankName && allSameBranchName) {
        localStorage.setItem('selectedInvoices', JSON.stringify(selected));
        navigate('view-multiple-invoice', {
          state: {
            selectedItem: selected
          }
        });
      } else {
        setSameBankPopUp(true);
      }
    }
  };

  const handleBranchDetails = (bankValue) => {
    const myValue = bankValue?.value || bankValue || null;
    if (!myValue) {
      // setValue('branchId', null);
      dispatch(setBranchDetails(null));
      return '';
    }
    dispatch(getBankBranchData(myValue));
  };

  const isRaiseInvoiceDisabled = () => {
    if (!selected || selected.length === 0) {
      return true; // disabled when no selection
    }
    // Disable if ANY selected item has misIsMatch === false
    const hasAnyMismatched = selected.some((item) => item?.misIsMatch !== true);
    return hasAnyMismatched;
  };

  return (
    <>
      {isOpenFilter && (
        <Box px={3} pt={2}>
          <Grid container spacing={3}>
            <Grid item xs>
              <Autocomplete
                id="combo-box-demo2"
                options={BankDrop || []}
                size="small"
                value={BankDrop?.find((opt) => opt.value === filterParameter?.bankId) || null}
                getOptionLabel={(option) => option?.label || ''}
                renderOption={(props, option) => <li {...props}>{option?.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Bank" />
                )}
                onChange={async (e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    branchId: null,
                    bankId: newValue?.value ? newValue?.value : newValue
                  }));
                  handleBranchDetails(newValue);
                }}
              />
            </Grid>
            <Grid item xs>
              <Autocomplete
                sx={{ mr: 2 }}
                fullWidth
                disabled={!filterParameter?.bankId}
                id="combo-box-demo3"
                size="small"
                options={BankBranchDrop || []}
                renderOption={(props, option) => <li {...props}>{option?.label}</li>}
                renderInput={(params) => (
                  <TextField {...params} fullWidth placeholder="Select Branch" />
                )}
                value={
                  BankBranchDrop?.find((opt) => opt.value === filterParameter?.branchId) || null
                }
                getOptionLabel={(option) => option?.label || ''}
                onChange={(e, newValue) => {
                  setFilterParameter((pre) => ({
                    ...pre,
                    branchId: newValue?.value ? newValue?.value : newValue
                  }));
                }}
              />
            </Grid>
            <Grid item xs>
              <Select
                fullWidth
                displayEmpty
                inputProps={{
                  className: `textInput customSelectBox dissabledMenu${filterParameter?.loanTypeId}`
                }}
                value={filterParameter?.loanTypeId ?? ''}
                onChange={(e) => {
                  const raw = e.target.value;
                  // if placeholder or empty string, set null; convert numbers if needed
                  const cleaned = raw === '' ? null : raw;
                  setFilterParameter((pre) => ({
                    ...pre,
                    loanTypeId: cleaned
                  }));
                }}
              >
                <MenuItem value="" disabled>
                  Select Product Type
                </MenuItem>
                {LoanTypeDrop?.map((item) => (
                  <MenuItem key={item?.value} value={item?.value}>
                    {item?.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs="auto">
              <Tooltip title="Reset Filter">
                <IconButton onClick={(e) => handleRemoveFilter(e)} size="small">
                  <FilterListOffIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </Box>
      )}

      <RootStyle
        sx={{
          minHeight: 45,
          borderBottom: '1px solid #eaedf1'
        }}
      >
        <Box>
          <Tooltip title="Raise Invoice" placement="top" arrow>
            {/* {console.log('selected in toolbar', selected?.[0]?.misIsMatch)} */}
            <StyledIconButton
              disabled={isRaiseInvoiceDisabled()}
              classes={{ disabled: 'disabledBtn' }}
              className="squareIconButton"
              onClick={handleButtonClick}
            >
              <FaFileInvoice size={18} />
            </StyledIconButton>
          </Tooltip>
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Download Invoice" placement="top" arrow>
            <StyledIconButton
              className="squareIconButton"
              onClick={(e) => {
                setDownloadPopup(true);
              }}
            >
              <BiCloudDownload size={18} />
            </StyledIconButton>
          </Tooltip>{' '}
        </Box>
        <Box>
          <SearchStyle
            value={filterName}
            onChange={onFilterName}
            placeholder="Search Receivable"
            classes={{
              root: 'searchHolder',
              input: 'searchInput'
            }}
            startAdornment={
              <InputAdornment position="start">
                <Box component={Icon} icon={searchFill} sx={{ color: 'text.disabled' }} />
              </InputAdornment>
            }
          />
          &nbsp;&nbsp;&nbsp;
          <Tooltip title="Filter list">
            <IconButton
              onClick={(e) => {
                if (isOpenFilter) {
                  openFilter(false);
                } else {
                  openFilter(true);
                }
              }}
            >
              <Icon icon={roundFilterList} />
            </IconButton>
          </Tooltip>
        </Box>
      </RootStyle>
      {/* Download pop up start */}
      <Dialog
        className="PopupBox"
        open={downloadPopup}
        onClose={(e) => setDownloadPopup(false)}
        fullWidth
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Download</Typography>
          <IconButton onClick={(e) => setDownloadPopup(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" textAlign="center">
            Are you sure you want to download?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDownloadReceivableReports} variant="contained" className="mainBtn">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      {/* Download pop up end */}
      <Dialog open={openAdd} onClose={(e) => setOpenAdd(false)} fullWidth>
        <DialogTitle className="popupTitle">
          <Typography>Select Mode of Application Submission</Typography>
          <IconButton onClick={(e) => setOpenAdd(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={3}
            display="flex"
            justifyContent="space-between"
            textAlign="center"
            mb={2}
          >
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                onClick={(e) => {
                  window.open(`http://losdemo.kalolytic.com/`, `_blank`);
                  setOpenAdd(false);
                }}
              >
                <HiStatusOnline className="appSubLinkIcon" />
                <Typography variant="subtitle1">Online</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                onClick={(e) => {
                  window.open(`http://offline-prod.kalolytic.com/`, `_blank`);
                  setOpenAdd(false);
                }}
              >
                <HiOutlineStatusOffline className="appSubLinkIcon" />
                <Typography variant="subtitle1">Offline</Typography>
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box
                className="appSubmissionLinkB"
                onClick={(e) => {
                  window.open(`http://offline-prod.kalolytic.com/`, `_blank`);
                  setOpenAdd(false);
                }}
              >
                <RiListSettingsLine className="appSubLinkIcon" />
                <Typography variant="subtitle2">Manual</Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
      <Dialog open={openAssign} onClose={(e) => setOpenAssign(false)} fullWidth>
        <Box>
          <Box>
            <DialogTitle>27 Prospect Selected</DialogTitle>
          </Box>
        </Box>
        <DialogContent>
          <Select
            fullWidth
            inputProps={{
              className: 'textInput'
            }}
            value={assignValue}
            onChange={(e) => setAssignValue(e.target.value)}
          >
            <MenuItem value=" " disabled>
              Select
            </MenuItem>
            <MenuItem value="sbi">SBI</MenuItem>
            <MenuItem value="axisbank">AXIS BANK</MenuItem>
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setOpenAssign(false)} variant="contained">
            SUBMIT
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        className="PopupBox"
        open={sameBankPopUp}
        onClose={(e) => setSameBankPopUp(false)}
        fullWidth
      >
        <DialogTitle className="popupTitle">
          <Typography variant="h6">Raise Invoice</Typography>
          <IconButton onClick={(e) => setSameBankPopUp(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Typography variant="body2" textAlign="center">
            Selected items have different bank or branch names. Please select same bank and branch
            names files.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => setSameBankPopUp(false)} variant="contained" className="mainBtn">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Loader openLoader={openLoader} />
    </>
  );
}
